import React, { useState } from 'react';
import { useTranslation } from 'react-i18next';
import i18next from 'i18next';
import { Icon } from 'react-inv-forms';

import { LanguageConfig, Language, localStorageLanguageKey } from '../../../settings/i18n/languages';
import LanguageSwitcherStyleWrapper from './LanguageSwitcher.style';
import arrowDownBlack from '../../../images/arrowDownBlack.svg';
import storageManager from '../../../helpers/storageManager';

interface ILanguageSwitcher {
  /** aktualny język aplikacji */
  currentLanguage: Language;
  /** akcja zmieniająca język */
  setLanguage: (languageKey: Language) => void;
  /** dostępne języki w aplikacji */
  languages: LanguageConfig;
}

/**
 * Komponent dostarczający interfejs do przełączania wersji językowych w aplikacji.
 *
 */
const LanguageSwitcher = ({ currentLanguage, setLanguage, languages }: ILanguageSwitcher): JSX.Element => {
  const { t } = useTranslation();
  const [languageListOpened, setLanguageListOpened] = useState(false);

  const handleLanguageChange = (languageKey: Language): void => {
    setLanguage(languageKey);
    i18next.changeLanguage(languageKey);
    storageManager.set(localStorageLanguageKey, languageKey);
  };

  return (
    <section>
      <button className='btn' onClick={() => setLanguageListOpened(!languageListOpened)}>
        {t('CHANGE_LANGUAGE')}
        <Icon path={arrowDownBlack} className={`icon${languageListOpened ? '__turned' : ''}`} />
      </button>
      <LanguageSwitcherStyleWrapper visible={languageListOpened}>
        {Object.values(Language).map((language: Language) => (
          <li
            className={language === currentLanguage ? 'active' : ''}
            onClick={() => handleLanguageChange(language)}
            key={language}
          >
            {languages[language].localName}
          </li>
        ))}
      </LanguageSwitcherStyleWrapper>
    </section>
  );
};

export default LanguageSwitcher;
